import { StylesPanelComponent } from 'src/app/map/custom-controls/components/styles-panel/styles-panel.component';

import { MatDialog } from '@angular/material/dialog';

import { isNil } from './utils';
import mapboxgl from 'mapbox-gl';
import { distinctUntilChanged, filter, skip, tap } from 'rxjs';

export const setSavedMapLayerStyle = (
  localStorageId: string,
  mapLayers: {
    name: string;
    style: string;
  }[],
  setStyle: (style: string) => void
) => {
  const savedMapLayerName = localStorage.getItem(localStorageId);
  if (!isNil(savedMapLayerName)) {
    const savedMapLayer = mapLayers.find(
      mapLayer => mapLayer.name === savedMapLayerName
    );
    setStyle('mapbox://styles/' + savedMapLayer.style);
  }
};

export const onSelectLayer = (
  dialog: MatDialog,
  map: mapboxgl.Map,
  localStorageId: string = '',
  preStyleLoadAction: (mapLayer?: any) => void,
  onStyleLoadAction: (mapLayer?: any) => void
) => {
  const dialogRef = dialog.open(StylesPanelComponent, {
    id: 'StylesPanelComponent',
    maxHeight: '70vh',
    enterAnimationDuration: '300ms',
    exitAnimationDuration: '300ms',
    disableClose: true,
    data: { localStorageId },
  });

  const dialogRefSubscription = dialogRef.componentInstance.selectedLayerStyle$
    .pipe(
      distinctUntilChanged(),
      filter(mapLayer => mapLayer != null),
      skip(1),
      tap(mapLayer => {
        preStyleLoadAction(mapLayer);
        const onStyleLoad = () => {
          onStyleLoadAction(mapLayer);
          map.off('style.load', onStyleLoad);
        };
        map.on('style.load', onStyleLoad);
        map.setStyle('mapbox://styles/' + mapLayer.style, {
          diff: true,
          localFontFamily: '',
          localIdeographFontFamily: '',
        });
      })
    )
    .subscribe(() => {});

  dialogRef
    .afterClosed()
    .pipe(tap(() => dialogRefSubscription?.unsubscribe()))
    .subscribe(() => {});
};
